import { Skeleton, Divider, Menu, Modal, Row, Col, Button, ConfigProvider, Upload, Card, Input, Tabs, Typography, message } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import styled from 'styled-components';
import './css/cramSchool.css';
import ShareLearningModal from './components/ShareLearningModal';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import TitleModal from './components/TitleModal';
import WYSIWYGModal from './components/WYSIWYGModal';
import Carousel_news_ticker from './components/Carousel_news_ticker';
// import InfiniteScroll from './components/InfiniteScroll';
import InfiniteScroll from 'react-infinite-scroll-component';
import Label_language from '../language';
const { Title, Paragraph, Text, Link } = Typography;
const { Dragger } = Upload;
const { TextArea } = Input;
const { confirm } = Modal;
const label_language = Label_language.cramschool.children
const CustomTabs = styled.div`
    .ant-tabs-tab{
        font-size :24px;
        font-weight: 700;
        border-radius: 10px;
        background-color: #F5F5F5;
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active{
        font-size :30px;
        font-weight: 700;
        background-color: #F5F5F5 !important;
        border-radius: 20px;
    }
    .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab{
      padding:15px;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
    //   color:#FFFFFF; 
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab{
    //   background:#FFF4C1;
      font-size :17px;
    }
    .ant-tabs-tab:hover {
        color: #bbb;
        background: #F5F5F5;
    }
    .ant-tabs-tab-btn:focus, .ant-tabs-tab-remove:focus, .ant-tabs-tab-btn:active, .ant-tabs-tab-remove:active {
        color: #F5F5F5;
    }
`;
const ShareLearning = () => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const navigate = useNavigate();
    const [page, setpage] = useState(1);
    const [total, setTotal] = useState(1);
    const [itemdatacheck, setitemdatacheck] = useState(true);
    const [fileList, setFileList] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [title, setTitle] = useState('新增');
    const [pic_title, set_pic_title] = useState('修改');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [pic_open, set_pic_open] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [title_modal, set_tiltle_modal] = useState(false);
    const [titleEditcard, setTitleEditCard] = useState({ background_color: null, color_show: null, file_show: null, file_id: [], file_url: [] });
    const [permission, setPermission] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [activeKey, setActiveKey] = useState(null);
    const [tabedit, setTabEdit] = useState('');
    const [content, setContent] = useState('');
    const [edit_tab_name, set_edit_tab_name] = useState('');
    const [data, setData] = useState([]);
    const [items, setItems] = useState([])
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    // useEffect(() => {
    //     setItems(pre => {
    //         return Object.keys(data).map((value, key) => {
    //             return {
    //                 label: value,
    //                 key: key + 1,
    //                 children: (
    //                     <>
    //                         <Row gutter={[40, 16]} justify='center'>
    //                             {
    //                                 // console.log(data)
    //                                 data && data[value].learn_witness.map((item, index) => {
    //                                     return (
    //                                         <>
    //                                             < Col sm={{ span: 24 }
    //                                             } md={{ span: 8 }} justify='center' >
    //                                                 <Card
    //                                                 // style={{ minHeight: "17rem", position: 'relative', alignItems: 'center' }}
    //                                                 // style={{ backgroundColor: value.background_color || '#ffffff' }}
    //                                                 // onClick={e => navigate(`/cramSchool/ShareLearning/${item['learn_witness_id']}`)}
    //                                                 >
    //                                                     <Row gutter={[24, 16]} style={{ minHeight: "15rem", position: 'relative', alignItems: 'center' }}>
    //                                                         <Col span={24} style={{ padding: '50px' }}>
    //                                                             {permission ? <>
    //                                                                 <Row style={{ position: 'relative', justifyContent: 'end', }}>
    //                                                                     <Col className='example' style={{ position: 'absolute', left: '100%', top: '0%', zIndex: 99 }}>
    //                                                                         <EditOutlined
    //                                                                             className='example'
    //                                                                             style={{
    //                                                                                 backgroundColor: '#F9D4E5',
    //                                                                                 fontSize: '1.2rem',
    //                                                                                 borderRadius: '50%',
    //                                                                                 padding: '8px'
    //                                                                             }}
    //                                                                             onClick={e => handleOnEdit(value, item.learn_witness_id)}
    //                                                                         />
    //                                                                     </Col>
    //                                                                 </Row>
    //                                                             </>
    //                                                                 : null}
    //                                                             <Carousel_news_ticker
    //                                                                 // logo
    //                                                                 // height={'100%'}
    //                                                                 url={`/cramSchool/ShareLearning/${item['learn_witness_id']}`}
    //                                                                 file_url={value['file_url']} />
    //                                                         </Col>
    //                                                         <Col span={24}
    //                                                             onClick={e => navigate(`/cramSchool/ShareLearning/${item['learn_witness_id']}`)}
    //                                                         >
    //                                                             < Row gutter={[8, 8]} style={{ textAlign: 'center' }}>
    //                                                                 <Col span={24}>
    //                                                                     <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{value['title']}</span>
    //                                                                 </Col>
    //                                                                 {dimensions['width'] > 500 &&
    //                                                                     (<Col span={24}>
    //                                                                         <Paragraph
    //                                                                             ellipsis={{
    //                                                                                 rows: 1,
    //                                                                                 expandable: true,
    //                                                                                 symbol: 'more',
    //                                                                             }}
    //                                                                         >
    //                                                                             {value?.['content'] && (<>
    //                                                                                 {(String(value?.['content']) || '').split('\n').map(map_item => (<>
    //                                                                                     {map_item}<br />
    //                                                                                 </>))}
    //                                                                             </>)}
    //                                                                         </Paragraph>
    //                                                                     </Col>)}
    //                                                             </Row>
    //                                                         </Col>
    //                                                     </Row>
    //                                                 </Card>
    //                                             </Col>
    //                                         </>
    //                                     )
    //                                 })

    //                             }
    //                         </Row>
    //                     </>
    //                 )
    //             }
    //         })
    //     })
    //     Object.keys(data).map((value, key) => {
    //         data[value].learn_witness.forEach(each_item => {
    //             if (each_item.learn_witness_id === editcard.learn_witness_id) {
    //                 setEditCard(prev => (
    //                     {
    //                         ...prev,
    //                         file_url: each_item.file_url
    //                     }
    //                 ))
    //             }
    //         })
    //     })
    // }, [data])
    const get_tab = () => {
        axios
            .get('/cramSchool/api/learn_witness/type')
            .then((response) => {
                setActiveKey(response.data[0].learn_witness_type_id)
                setItems(response.data);
                get_data(response.data[0].learn_witness_type_id);
            })
    }
    useEffect(() => {
        setpage(1);
        get_data(activeKey);
    }, [activeKey])
    const get_data = (id) => {
        if (id != null) {
            axios
                .get('/cramSchool/api/learn_witness', { params: { cur_page: page, size: 9, learn_witness_type_id: id } })
                .then((response) => {
                    if (page == 1) {
                        setData(response.data.data);
                        setTotal(response.data.total)
                        get_picture(response.data.data);
                    } else {
                        setData(pre => { return ([...pre, ...response.data.data]) });
                        setTotal(response.data.total)
                        get_picture([...data, ...response.data.data]);
                    }
                })
                .finally(() => {
                    setitemdatacheck(false)
                })
        }
    }
    const get_picture = (data_tmp) => {
        // Object.keys(data_tmp).forEach((value, key) => {
        //     if (data_tmp[value].learn_witness.length != 0) {
        //         data_tmp[value].learn_witness.map((temp, index) => {
        //             let learn_witness_id = temp['learn_witness_id'];
        //             if (temp['file_id'].length != 0) {
        //                 temp.file_id.map((tmp, key) => {
        //                     axios
        //                         .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
        //                         .then((response) => {
        //                             var blob_ = new Blob([response.data], {
        //                                 type: "image/jpg",// this is the only MIME for SVG
        //                             });
        //                             const dataurl = URL.createObjectURL(blob_);
        //                             setData(
        //                                 (pre) => {
        //                                     // console.log(pre,value)
        //                                     return ({
        //                                         ...pre,
        //                                         [value]: {
        //                                             ...pre[value],
        //                                             learn_witness: pre[value]['learn_witness'].map((value, index) => {
        //                                                 if (learn_witness_id == value.learn_witness_id) {
        //                                                     if (value.file_url != undefined) {
        //                                                         return (
        //                                                             {
        //                                                                 ...value,
        //                                                                 file_url: [...value.file_url, dataurl]
        //                                                             }
        //                                                         )
        //                                                     } else {
        //                                                         return (
        //                                                             {
        //                                                                 ...value,
        //                                                                 file_url: [dataurl]
        //                                                             }
        //                                                         )
        //                                                     }
        //                                                 } else {
        //                                                     return (
        //                                                         { ...value }
        //                                                     )

        //                                                 }
        //                                             })
        //                                         }
        //                                     })
        //                                 }
        //                             )
        //                         })
        //                 })
        //             }
        //         })
        //     }
        // })
        data_tmp && data_tmp.map((value, index) => {
            let learn_witness_id = value['learn_witness_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (learn_witness_id == value.learn_witness_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    // useEffect(() => {
    //     console.log(data)
    // }, [data])
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/sharelearning', { params: { "blog_type_id": 17 } })
            .then((response) => {
                setContent(response.data.data[0]);
            })
    }
    const get_title = () => {
        axios
            .get('/cramSchool/api/blog/type', { params: { 'blog_type_id': 17 } })
            .then((response) => {
                let color_tmp = response.data.data[0].background_color.split(',');
                // console.log(color_tmp);
                setTitleEditCard(
                    (pre) => {
                        return (
                            {
                                ...pre,
                                background_color1: color_tmp[0],
                                background_color2: color_tmp[1],
                                color_show: response.data.data[0].color_show,
                            }
                        )
                    }
                )
                if (response.data.data[0].file_id.length != 0) {
                    let data_tmp = [];
                    response.data.data[0].file_id.map((tmp, i) => {
                        axios
                            .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                            .then((response) => {
                                var blob_ = new Blob([response.data], {
                                    type: "image/jpg",// this is the only MIME for SVG

                                });
                                const dataurl = URL.createObjectURL(blob_);
                                data_tmp.push({ uid: tmp, url: dataurl })
                                setTitleEditCard((pre) => {
                                    if (tmp.file_url != undefined) {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [...tmp.file_id, tmp],
                                                file_url: [...tmp.file_url, dataurl]
                                            }
                                        )
                                    } else {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [tmp],
                                                file_url: [dataurl]
                                            }
                                        )
                                    }
                                })
                            })
                    })
                    setTitleEditCard((pre) => {
                        return (
                            {
                                ...pre,
                                file_show: response.data.data[0].file_show,
                                // file_id: data_tmp.map((item) => item.uid),
                                // file_url: data_tmp.map((item) => item.url)
                            }
                        )
                    })
                }
            })
    }
    useEffect(() => {
        get_tab();
        get_header();
        get_title();
    }, [])

    const newTabIndex = useRef(1);
    const onChange = (newActiveKey) => {
        setActiveKey(newActiveKey);
    };
    // const [data, setData] = useState([]);
    const add = () => {
        const newActiveKey = `新分類${newTabIndex.current++}`;
        const newPanes = [...items];
        newPanes.push({
            label: newActiveKey,
            children: '',
            key: newActiveKey,
        });
        axios
            .post('/cramSchool/api/learn_witness/type', [{ "name": newActiveKey }])
            .then((response) => {
                if (response.data.status == 'success') {
                    // setItems(newPanes);
                    // setActiveKey(newActiveKey);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    get_tab();
                } else {
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                }
            })
    };

    useEffect(() => {
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
    }, [])
    // useEffect(() => {
    //     console.log(data)
    // }, [data])
    const remove = (targetKey) => {
        const deleterow = [{ "learn_witness_type_id": targetKey }];
        axios
            .delete('/cramSchool/api/learn_witness/type', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_tab();
                }
            })
    };

    const onEdit = (targetKey, action) => {
        // console.log(targetKey)
        if (action === 'add') {
            add();
        } else {
            showConfirm(targetKey);
            // remove(targetKey);
        }
    };

    const handleOnEdit = (item) => {
        setTitle('修改');
        setColor('f09a45');
        setEdit(true);
        // data[value].learn_witness.map((item, index) => {
        //     if (item.learn_witness_id == id) {
        //         setEditCard({ ...item, "learn_witness_type_name": value, "learn_witness_type_id": data[value].learn_witness_type_id });
        //     }
        // })
        setEditCard(item);
        setOpen(true)
    }
    const handleOnEditPic = () => {
        setEdit(true);
        setColor('f09a45');
        setEditCard(fileList);
        set_pic_open(true)
    }
    const handleOnEditTab = () => {
        axios
            .patch('/cramSchool/api/learn_witness/type', [{ "learn_witness_type_id": tabedit, "name": edit_tab_name }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_tab();
                }
                setTabEdit('');
                set_edit_tab_name('');
            })
    }

    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        if (JSON.stringify(editcard) == '{}' || editcard['learn_witness_type_id'] == undefined || editcard['learn_witness_type_id'] == '') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '請填寫必填欄位',
            });
        } else {
            axios
                .patch(`/cramSchool/api/learn_witness`, [{ ...editcard, file_id }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                        get_tab();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        get_tab();
                    }
                })
        }
    }

    const handleSubmit = (file_id) => {
        // console.log(editcard);
        if (JSON.stringify(editcard) == '{}' || editcard['learn_witness_type_id'] == undefined || editcard['learn_witness_type_id'] == '') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '請填寫必填欄位',
            });
        } else {
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            axios
                .post(`/cramSchool/api/learn_witness`, [{ ...editcard, file_id }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_tab();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_tab();
                    }
                })
        }
        // console.log(editcard); 
    }

    const handleDelete = (id) => {
        const deleterow = [{ "learn_witness_id": id }];
        axios
            .delete('/cramSchool/api/learn_witness', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_tab();
                }
            })

    }
    const showConfirm = (targetKey) => {
        confirm({
            title: '確認刪除此標籤嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(targetKey)
            },
        });
    };
    const handleUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/sharelearning`, [{
                // "title": 'teacher_blog_header',
                // "content": content,
                ...content,
                "blog_type_id": 18,
                "annoucement_time": time,
                // "blog_id": 105

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                }
                get_header();
                set_open_wyswyg(false);
            })
    }
    const handleTitleUpdate = (file_id) => {
        // console.log({ ...titleEditcard, background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`, file_id: file_id });
        axios
            .patch('/cramSchool/api/blog/type', [{
                ...titleEditcard,
                background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`,
                file_id: file_id,
                blog_type_id: 17
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_title();
            })
    }
    useEffect(() => {
        // console.log(page)
        get_data(activeKey);
    }, [page])
    const ChangePage = () => {
        if (itemdatacheck) {
            return;
        }
        // setLoading(true);
        setitemdatacheck(false);
        setpage(pre => pre + 1)
    }
    return (
        <>
            <CustomTabs>
                {contextHolder}
                <ShareLearningModal
                    open={open}
                    edit={edit}
                    title={title}
                    color={color}
                    // setData={setData}
                    // data={data}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    setOpen={setOpen}
                    handleEdit={handleEdit}
                    handleSubmit={handleSubmit}
                    handleDelete={handleDelete}
                    destroyOnClose
                />
                <WYSIWYGModal
                    open={open_wyswyg}
                    setOpen={set_open_wyswyg}
                    data={content?.content}
                    setData={setContent}
                    handleUpdate={handleUpdate}
                />
                <TitleModal
                    open={title_modal}
                    setOpen={set_tiltle_modal}
                    title={'修改'}
                    color={'f09a45'}
                    edit={true}
                    name={'學習見證分享'}
                    editcard={titleEditcard}
                    setEditCard={setTitleEditCard}
                    handleEdit={handleTitleUpdate}
                    fileShow={true}
                />
                <Row gutter={[40, 16]} style={{ paddingTop: '10px' }} justify={'end'}>
                    {permission ? <>
                        <Col >
                            <Button className='example' style={{ backgroundColor: '#f09a45', color: '#FFFFFF' }} onClick={e => set_tiltle_modal(true)}>編輯標題</Button>
                        </Col>
                    </> : null}
                    {titleEditcard?.color_show == 1 ? <Col span={24}>
                        <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${titleEditcard.background_color1}, #ffffff,${titleEditcard.background_color2})`, padding: '10px', position: 'relative' }}>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3rem' }}>學習見證分享</span>
                            </Col>
                            {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                        </Col> */}
                        </Row>
                    </Col> : null}
                    {titleEditcard?.file_show == 1 ? <Col span={24}>
                        <Carousel_news_ticker
                            logo
                            height={'100%'}
                            file_url={titleEditcard?.file_url != undefined && titleEditcard?.file_url.length != 0 && titleEditcard?.file_url.map(map_item => map_item)}
                        />
                    </Col> : null}
                    <Col span={24}>
                        <Row gutter={[40, 16]} justify="center" align="middle" style={{ padding: '10px' }}>
                            <Col md={{ span: 6 }} sm={{ span: 24 }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                    <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                </Row>
                            </Col>
                            <Col md={{ span: 8 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                                <Row justify={'center'}>
                                    <Col >
                                        <span dangerouslySetInnerHTML={{ __html: content.content }}></span>
                                    </Col>
                                </Row>
                                {permission ? <>
                                    <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                        <EditOutlined
                                            className='example'
                                            style={{
                                                backgroundColor: '#F9D4E5',
                                                fontSize: '1.2rem',
                                                borderRadius: '50%',
                                                padding: '8px'
                                            }}
                                            onClick={e => set_open_wyswyg(true)}
                                        />
                                    </Col>
                                </> : null}
                            </Col>
                            <Col md={{ span: 6 }} sm={{ span: 24 }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                    <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[40, 16]} style={{ backgroundColor: '#F5f5F5', paddingTop: '10px', paddingBottom: '30px' }}>
                            {permission ? <>
                                <Col span={24}>
                                    <Row justify="end" >
                                        <Col>
                                            <Button className='example' style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('新增'); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true) }}
                                                icon={<PlusOutlined />}
                                            >新增學習見證</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </> : <></>}
                            <Col span={24}>
                                <Tabs
                                    tabBarStyle={{
                                        border: 'hidden'
                                    }}
                                    type={permission ? "editable-card" : "card"}
                                    onChange={onChange}
                                    activeKey={activeKey}
                                    onEdit={onEdit}
                                    items={items && items.map((value, i) => {
                                        return {
                                            label: (
                                                <>
                                                    <Col span={24}>
                                                        <Row gutter={16} align="bottom">
                                                            {tabedit == `${value.learn_witness_type_id}` ?
                                                                <>
                                                                    <Col >
                                                                        <Input defaultValue={value.name} onChange={(e) => set_edit_tab_name(e.target.value)}></Input>
                                                                    </Col>
                                                                    <Col>
                                                                        <Button className='example' type="primary" onClick={handleOnEditTab}>完成</Button>
                                                                    </Col>
                                                                </> : <>
                                                                    {permission ? <>
                                                                        <Col>
                                                                            <EditOutlined
                                                                                className='example'
                                                                                style={{
                                                                                    backgroundColor: '#F9D4E5',
                                                                                    fontSize: '1.2rem',
                                                                                    borderRadius: '50%',
                                                                                    padding: '8px'
                                                                                }}
                                                                                onClick={(e) => { setTabEdit(value.learn_witness_type_id); set_edit_tab_name(value.name); }}
                                                                            />
                                                                        </Col>
                                                                    </> : null}
                                                                    {permission ? <>
                                                                        <span onDoubleClick={(e) => { setTabEdit(value.learn_witness_type_id); set_edit_tab_name(value.name); }}>{value.name}</span>
                                                                    </> : <>
                                                                        <span >{value.name}</span>
                                                                    </>}
                                                                </>}
                                                        </Row>
                                                    </Col>
                                                </>
                                            ),
                                            key: value.learn_witness_type_id,
                                            children: (
                                                <>
                                                    {/* <InfiniteScroll
                                                        data={}
                                                        page={page}
                                                        total={total}
                                                        size={9}
                                                        setpage={e => setpage(e)}
                                                        loading={itemdatacheck}
                                                        method="window" /> */}
                                                    <InfiniteScroll
                                                        dataLength={data?.length}
                                                        next={ChangePage}
                                                        hasMore={data?.length < total}
                                                        loader={
                                                            <Skeleton
                                                                paragraph={{
                                                                    rows: 1,
                                                                }}
                                                                active
                                                            />
                                                        }
                                                        endMessage={<Divider plain>已經沒有貼文囉</Divider>}
                                                        scrollableTarget="scrollableDiv"
                                                    >
                                                        <Row gutter={[16, 16]} style={{ padding: '10px' }}>
                                                            {data && data.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        < Col sm={{ span: 24 }
                                                                        } md={{ span: 8 }} justify='center' >
                                                                            <Card>
                                                                                <Row gutter={[24, 16]} style={{ minHeight: "15rem", position: 'relative', alignItems: 'center' }}>
                                                                                    <Col span={24} style={{ padding: '50px' }}>
                                                                                        {permission ? <>
                                                                                            <Row style={{ position: 'relative', justifyContent: 'end', }}>
                                                                                                <Col className='example' style={{ position: 'absolute', left: '100%', top: '0%', zIndex: 99 }}>
                                                                                                    <EditOutlined
                                                                                                        className='example'
                                                                                                        style={{
                                                                                                            backgroundColor: '#F9D4E5',
                                                                                                            fontSize: '1.2rem',
                                                                                                            borderRadius: '50%',
                                                                                                            padding: '8px'
                                                                                                        }}
                                                                                                        onClick={e => handleOnEdit(item)}
                                                                                                    />
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </>
                                                                                            : null}
                                                                                        <Carousel_news_ticker
                                                                                            url={`/cramSchool/ShareLearning/${item['learn_witness_id']}`}
                                                                                            file_url={item['file_url']} />
                                                                                    </Col>
                                                                                    <Col span={24}
                                                                                        onClick={e => navigate(`/cramSchool/ShareLearning/${item['learn_witness_id']}`)}
                                                                                    >
                                                                                        < Row gutter={[8, 8]} style={{ textAlign: 'center' }}>
                                                                                            <Col span={24}>
                                                                                                <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{item['title']}</span>
                                                                                            </Col>
                                                                                            {dimensions['width'] > 500 &&
                                                                                                (<Col span={24}>
                                                                                                    <Paragraph
                                                                                                        ellipsis={{
                                                                                                            rows: 1,
                                                                                                            expandable: true,
                                                                                                            symbol: 'more',
                                                                                                        }}
                                                                                                    >
                                                                                                        {item?.['content'] && (<>
                                                                                                            {(String(item?.['content']) || '').split('\n').map(map_item => (<>
                                                                                                                {map_item}<br />
                                                                                                            </>))}
                                                                                                        </>)}
                                                                                                    </Paragraph>
                                                                                                </Col>)}
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Card>
                                                                        </Col>
                                                                    </>
                                                                )
                                                            })
                                                            }
                                                        </Row>
                                                    </InfiniteScroll>
                                                </>
                                            ),
                                        }
                                    })}
                                // items={items}
                                />
                            </Col>
                        </Row >
                    </Col>
                </Row >
            </CustomTabs >
        </>
    )
}

export default ShareLearning;